import { render, staticRenderFns } from "./UserHome.vue?vue&type=template&id=189c7be8&"
import script from "./UserHome.ts?vue&type=script&lang=ts&"
export * from "./UserHome.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports